import { baseApi as api } from '../api'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({}),
  overrideExisting: false,
})
export { injectedRtkApi as api }
export const {} = injectedRtkApi
